<script>
	// Stores 
	import { textSite } from '../store.js';    

	// Componentes Svelte
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';
	import ListaImoveis from './../components/ListaImoveis.svelte'

	let filtrosDestaques = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1};

	// Event snippet for Clique botão whatsapp conversion page 
	gtag('event', 'conversion', {'send_to': 'AW-711595799/bLJrCPXsm5YZEJeuqNMC'});

</script>

<PageHeader title="Obrigado pelo contato!"></PageHeader>
<div class="container">
	<section class="section lista-imoveis">
		<ListaImoveis holderClass="grid grid-size--3 grid-size-md--3 grid-size-sm--2 grid-size-xs--1" colClass="item" filters={filtrosDestaques} showPaginator={false} />
	</section>
</div>